export const HOME = '/';
export const LOGIN = '/login';
export const SIGN_UP = '/sign-up';
export const JOBS = '/jobs';
export const MESSAGES = '/messages';
export const DRIVE = '/drive';
export const TARGETS = '/targets';
export const REPORTS = '/reports';
export const SETTINGS = '/settings';
export const PROFILE = '/profile';
export const ADMIN = '/admin';
export const FORGOT_PASSWORD = '/forgot-password';
